import Cmyk from '../../../../components/editable-cell/form-items/cmyk'
import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard } from '../../helpers/helpers'
import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import { hasTaskOfType } from '../../helpers/has-task-of-type'

export const cmykColumn: ShipmentColumn = {
    key: 'cmyk',
    dataIndex: 'cmyk',
    title: <RotatedTitle>CMYK</RotatedTitle>,
    width: 30,
    editable: true,
    FormItem: <Cmyk />,
    onCell: (record, index) => ({
        ...onCellStandard(record, index),
        editable: !hasTaskOfType(record, 'Заказ форм'),
    }) as any,
}
